// extracted by mini-css-extract-plugin
module.exports = {"root":"ExpandedServiceTypeSelector_root__UP7G6"};